import PropTypes from 'prop-types';
import { Carousel } from '@mantine/carousel';
import {
  createStyles,
  Text,
  Title,
  BackgroundImage,
  Container,
} from '@mantine/core';

const useStyles = createStyles((theme) => ({
  container: {
    width: '100%',
    marginLeft: 50,
  },
  slideWrapper: {},
  backgroundImage: {
    width: '450px!important',
    height: '100%',
    '@media (max-width: 600px)': {
      width: '400px!important',
    },
    '@media (max-height: 500px)': {
      height: '37vh!important',
      transition: '0.5s',
    },
    '@media (min-height: 500px) and (max-height: 600px)': {
      height: '37vh!important',
      transition: '0.5s',
    },
    '@media (min-height: 600px) and (max-height: 750px)': {
      height: '30vh!important',
      transition: '0.5s',
    },
  },
  containerText: {
    paddingTop: '35%',
    paddingBottom: 24,
    paddingLeft: 24,
    '@media (max-height: 500px)': {
      paddingTop: '20vh!important',
      transition: '0.5s',
    },
    '@media (min-height: 500px) and (max-height: 600px)': {
      paddingTop: '25vh!important',
      transition: '0.5s',
    },
    '@media (min-height: 600px) and (max-height: 750px)': {
      paddingTop: '20vh!important',
      transition: '0.5s',
    },
  },
  control: {
    backgroundColor: '#F2EEC8',
    color: '#F56600',
    borderColor: '#F2EEC8',
    opacity: 1,
  },
  title: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    fontSize: 20,
    textOverflow: 'ellipsis',
  },
  text: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: 16,
    fontWeight: 400,
    textOverflow: 'ellipsis',
  },
  anchor: {
    '&:hover': {
      color: theme.white,
      textDecoration: 'none',
    },
  },
}));
const CarouselCompo2 = (props) => {
  const { classes } = useStyles();
  return (
    <Carousel.Slide className={classes.slideWrapper}>
      {/* <Anchor href={`/properti?id=${props.id}`} className={classes.anchor}> */}
      <BackgroundImage
        src={`'${props.image} '`}
        className={classes.backgroundImage}
        radius="lg"
      >
        <Container className={classes.containerText}>
          <Title order={5} color="white" className={classes.title}>
            {props.title}
          </Title>
          <Text color="white" className={classes.text}>
            {props.address}
          </Text>
        </Container>
      </BackgroundImage>
      {/* </Anchor> */}
    </Carousel.Slide>
  );
};
// Default Value Props
CarouselCompo2.propTypes = {
  title: PropTypes.string,
};
// CarouselCompo2.defaultProps = {
//   image: 'Image not load',
//   title: 'No Title',
//   address: 'No Address',
// };
export default CarouselCompo2;
